import { Group } from '@mantine/core';
import { GlobalDocumentTemplateRes } from '@dealstack/shared/lib/generated';
import { createTextColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/TextColumn';
import { createDateColumn } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/DateColumn';
import { ExtendedColumnDef } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import {
	availabilityLabel,
	availabilityRank,
} from '@dealstack/frontend/app/pages/DocumentTemplates/TemplateAvailability/availabilityLabel';
import { EditTemplateButton } from './EditTemplateButton';
import { DeleteTemplateButton } from './DeleteTemplateButton';
import { AvailabilityCell } from './AvailabilityCell';
import { ManageAvailabilityButton } from './ManageAvailabilityButton';

const createDocumentTemplatesActionColumn = (): ExtendedColumnDef<GlobalDocumentTemplateRes> => {
	return {
		cell: ({ row }) => (
			<Group gap="xs" wrap="nowrap">
				<ManageAvailabilityButton templateId={row.original.id} />
				<EditTemplateButton templateId={row.original.id} />
				<DeleteTemplateButton template={row.original} />
			</Group>
		),
		header: '',
		id: 'actions',
		enableGlobalFilter: false,
		enableColumnFilter: false,
		filter: () => <div />,
		size: 220,
		meta: {
			isGrow: true,
		},
	};
};

export const documentTemplatesTableColumns: ExtendedColumnDef<GlobalDocumentTemplateRes>[] = [
	createTextColumn({ id: 'name', headerText: 'Template name', accessorKey: 'name' }),
	createTextColumn({ id: 'status', headerText: 'Status', accessorKey: 'status' }),
	{
		id: 'availability',
		header: 'Availability',
		// Accessor stays the label so the global filter matches what the user sees; sorting goes
		// through the rank so "10 deals" doesn't order before "2 deals".
		accessorFn: ({ availability, dealCount }) => availabilityLabel(availability, dealCount),
		cell: ({ row }) => <AvailabilityCell template={row.original} />,
		sortingFn: (rowA, rowB) =>
			availabilityRank(rowA.original.availability, rowA.original.dealCount) -
			availabilityRank(rowB.original.availability, rowB.original.dealCount),
		enableColumnFilter: false,
	},
	createDateColumn({
		id: 'updatedAt',
		headerText: 'Updated at',
		accessorFn: ({ updatedAt }) => !!updatedAt && new Date(updatedAt),
		sortingFn: 'datetime',
	}),
	createDocumentTemplatesActionColumn(),
];
